import React, {Component} from 'react';
import '../css/ae_footer.css';



class Footer extends Component {

  render() {


    let today = new Date();
    let date = today.getFullYear();



    return (
      <footer id="colophon" className="footer site-footer" role="contentinfo">
        <div className="ink-grid">
          <div className="column-group">
            <div className="xlarge-75 large-75 medium-100 small-100 tiny-100 push-center align-left">
              <div className="">
                <div className="column-group gutters">
                  <div className="xlarge-20 large-20 medium-50 small-50 tiny-100 push-left ">
                    <div className="menu-footer-column-1-container">
                      <ul id="menu-footer-column-1" className="menu">
                        <li id="menu-item-14267" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-14267"><a href="https://aecom.com/about-aecom/" target="_blank">About AECOM</a></li>
                        <li id="menu-item-23248" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-23248"><a href="https://www.aecom.com/markets" target="_blank">Markets</a></li>
                        <li id="menu-item-11590" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-11590"><a href="https://www.aecom.com/services/" target="_blank">Services</a></li>
                        <li id="menu-item-5640" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-5640"><a href="https://www.aecom.com/projects/" target="_blank">Projects</a></li>
                      </ul>
                    </div>
                  </div>
                <div className="xlarge-20 large-20  medium-50 small-50 tiny-100 push-left ">
                    <div className="menu-footer-column-2-container">
                      <ul id="menu-footer-column-2" className="menu">
                        <li id="menu-item-11595" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-11595"><a href="https://aecom.jobs" target="_blank">Careers</a></li>
                        <li id="menu-item-5644" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-5644"><a href="https://aecom.com/offices/" target="_blank">Offices</a></li>
                        <li id="menu-item-5644" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-5644"><a href="https://aecom.com/contact-us/" target="_blank">Contact Us</a></li>
                      </ul>
                    </div>
                  </div>
                    <div className="xlarge-20 large-20  medium-50 small-50 tiny-100 push-left ">
                    <ul className="menu">
                    <li id="menu-item-11595" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-11595"><a href="https://aecom.com/without-limits/" target="_blank">Without Limits</a></li>
                    <li id="menu-item-5644" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-5644"><a href="https://aecom.com/news/" target="_blank">News</a></li>
                    <li id="menu-item-5644" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-5644"><a href="https://aecom.com/blog/" target="_blank">Blog</a></li>
                    </ul>

                </div>
                <div className="xlarge-20 large-20  medium-50 small-50 tiny-100 push-left ">
                <ul className="menu">
                  <li id="menu-item-11595" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-11595"><a href="https://www.aecom.com/contract-vehicles/" target="_blank">Contract Vehicles</a></li>
                  <li id="menu-item-5644" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-5644"><a href="https://aecom.com/our-supply-chain/" target="_blank">Our Supply Chain</a></li>
                    <li id="menu-item-5644" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-5644"><a href="https://aecom.com/wp-content/uploads/documents/policies/AECOM-Modern-Slavery-Act-Statement.pdf" target="_blank">Modern Slavery Act Statement </a></li>
                    <li id="menu-item-5644" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-5644"><a href="https://aecom.com/privacy-policy/recruitment-privacy/" target="_blank">Recruitment Privacy Notice</a></li>
                </ul>

            </div>





              </div>
            </div>
          </div>
                <div className="xlarge-5 large-5 hide-medium hide-small hide-tiny push-left align-left "></div>
          <div className="xlarge-20 large-20 medium-100 small-100 tiny-100 push-left align-left ">
          <div className="logo-container"><a href="https://www.aecom.com/" rel="home"><img width="100" src="https://www.aecom.com/wp-content/themes/aecom/images/aecom-logo.png" alt="AECOM"/></a></div>
          <ul className="social-area custom-color round-social-icons footer-social-icons">
            <li><a href="https://www.facebook.com/AecomTechnologyCorporation/" target="_blank" title="Facebook"><i className="fa fa-facebook"></i></a></li>
            <li><a href="https://www.instagram.com/aecom/" target="_blank" title="Instagram"><i className="fa fa-instagram"></i></a></li>
            <li><a href="https://www.linkedin.com/company/aecom/" target="_blank" title="Linkedin"><i className="fa fa-linkedin"></i></a></li>
            <li><a href="https://twitter.com/AECOM" target="_blank" title="Twitter"><i className="fa fa-twitter"></i></a></li>
            <li><a href="https://www.youtube.com/user/AECOMTechnologyCorp" target="_blank" title="Youtube"><i className="fa fa-youtube-play"></i></a></li>
          </ul>
          <div>
          <div className="copyright">&copy; {date} AECOM. All Rights Reserved.</div>
          <ul className="menu_privacy">
            <li><a href="https://www.aecom.com/terms-use/" target="_blank">Terms of Use</a></li>
            <li><a href="https://www.aecom.com/privacy-policy/" target="_blank">Privacy Policy</a></li>
          </ul>

          </div>
          </div>



        </div>
        </div>
      </footer>)

  }

}
export default Footer;
